<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="680px"
      :before-close="handleClose"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="info" label-width="100px">
        <el-form-item label="作息名称">
          <el-select
            size="small"
            v-model="info.scheduleTypeId"
            placeholder="请选择"
            :disabled="addOrEdit == 1"
          >
            <el-option
              v-for="item in restList"
              :key="item.scheduleTypeId"
              :label="item.typeName"
              :value="item.scheduleTypeId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="作息表任务">
          <el-select
            size="small"
            v-model="info.scheduleConfigId"
            placeholder="请选择"
            clearable
            :disabled="addOrEdit == 1"
          >
            <el-option
              v-for="item in taskList"
              :key="item.scheduleConfigId"
              :label="item.configName"
              :value="item.scheduleConfigId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="广播名称">
          <el-input
            size="small"
            v-model.trim="info.scheduleName"
            placeholder="请填写广播名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="广播分区">
          <el-select
            v-if="broadcastBrand == 0"
            size="small"
            v-model="partition"
            multiple
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in partitionList"
              :key="item.areaNum"
              :label="item.areaName"
              :value="item.areaNum"
            >
            </el-option>
          </el-select>
          <el-cascader v-if="broadcastBrand == 1" ref="area" size="small" :options="areaList" :props="props" clearable @change="sel" v-model="areaValue"></el-cascader>
        </el-form-item>
        <el-form-item label="广播类型">
          <el-select
            size="small"
            v-model="info.broadcastType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in $store.state.select.broadcastClassification"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应用场景">
          <el-select
            size="small"
            v-model="info.scene"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in $store.state.select.sceneList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资源类型">
          <el-select
            size="small"
            v-model="info.resourceType"
            placeholder="请选择"
            clearable
          >
            <el-option label="音频" :value="0"></el-option>
            <!-- <el-option label="文本" :value="1"> </el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="广播次数">
          <el-input
            size="small"
            v-model.trim="info.frequency"
            placeholder="请填写广播次数"
          ></el-input>
        </el-form-item>
        <el-form-item label="广播音量">
          <el-input
            size="small"
            v-model.trim="info.volume"
            placeholder="请填写广播音量（1-56）"
          ></el-input>
          <span style="color:red;">注意：范围0-56；0为静音；</span>
        </el-form-item>
        <el-form-item label="广播资源" v-if="info.resourceType == 0">
          <el-input
            size="small"
            v-model.trim="info.resourcesName"
            placeholder="广播资源(广播资源类型是音频时使用)-100）"
            :readonly="true"
            @click.native="selResources"
          ></el-input>
        </el-form-item>
        <el-form-item label="广播内容" v-if="info.resourceType == 1">
          <el-input
            size="small"
            v-model.trim="info.broadcastContent"
            placeholder="广播内容(广播资源类型是文本时使用)-100）"
          ></el-input>
        </el-form-item>
        <el-form-item label="每周">
          <!-- {{info.week}} -->
          <el-checkbox-group v-model="week">
            <el-checkbox
              v-for="item in $store.state.select.weekList"
              :key="item.id"
              :label="item.id"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="广播开始时间">
          <el-time-picker
            size="small"
            placeholder="选择时间"
            v-model="info.broadcastStartTime"
            style="width: 100%;"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
          ></el-time-picker>
        </el-form-item>
        <el-form-item label="广播结束时间">
          <el-time-picker
            size="small"
            placeholder="选择时间"
            v-model="info.broadcastEndTime"
            style="width: 100%;"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
          ></el-time-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            size="small"
            type="textarea"
            v-model.trim="info.remarks"
            placeholder="请填写备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <broadcast-resources-dialog
      :dialogResize="dialogResize"
      :broadcastBrand="broadcastBrand"
    ></broadcast-resources-dialog>
  </div>
</template>

<script>
import broadcastResourcesDialog from "./RestBroadcastAddOrEditDialog.vue";
export default {
  name: "RestBroadcastAddOrEdit",
  components: {
    broadcastResourcesDialog
  },
  props: {
    operateResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    addOrEdit: {
      type: Number,
      default: {
        return: 0
      }
    },
    restSelected: {
      type: Number,
      default: {
        return: 0
      }
    },
    restList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    scheduleId: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      props: {
        multiple: true
      },
      areaList: [],
      areaValue: [],
      options: [],
      week: [],
      partition: [],
      title: "",
      dialogVisible: false,
      id: 0,
      taskList: [],
      partitionList: [],
      schoolId: parseInt(this.$store.state.schoolId),
      broadcastBrand: 0, // 0 智慧广播，1 云广播
      info: {
        scheduleId: "",
        scheduleTypeId: "",
        scheduleConfigId: "",
        schoolId: this.schoolId,
        partition: "",
        scheduleName: "",
        broadcastType: "",
        scene: "",
        resourceType: "",
        frequency: "",
        volume: "",
        broadcastResources: "",
        resourcesName: "",
        broadcastContent: "",
        broadcastStartTime: "",
        broadcastEndTime: "",
        week: "",
        remarks: ""
      },
      dialogResize: 0
    };
  },
  created() {},
  mounted() {},
  watch: {
    operateResize: function(newVal, oldVal) {
      if (this.addOrEdit == 0) {
        this.id = 0;
        this.title = "添加作息广播";
        this.clearData();
        this.info.scheduleTypeId = this.restSelected;
        // console.log(this.restSelected);
      } else {
        this.id = this.scheduleId;
        this.title = "修改作息广播";
      }
      this.getTaskList();
      this.getBroadcastBrand();
      this.dialogVisible = true;
    },
    selectBroadcastCatalogId: function (newVal,oldVal) {
      this.info.broadcastResources = newVal;
    },
    selectBroadcastName: function (newVal,oldVal) {
      this.info.resourcesName = newVal;
    }
  },
  computed: {
    selectBroadcastCatalogId() {
      return this.$store.state.selectBroadcastCatalogId
    },
    selectBroadcastName() {
      return this.$store.state.selectBroadcastName
    }
  },
  methods: {
    // 获取校园广播品牌
    async getBroadcastBrand() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getBroadcastBrand(req);
      if (res.code == 200) {
        this.broadcastBrand = res.data;
        this.getBroadcastAreaInfo();
        if (this.addOrEdit == 1) {
          this.getRestBroadcastInfo();
        }        
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    sel() {
      // console.log(this.areaValue)
      let areaValue = this.areaValue;
      let selectArea = this.modifyArea(areaValue);
      // console.log(selectArea)
    },
    modifyArea(list) {
      let array = list.map((element) => {
        return element[1]
      });
      return array;
    },
    selResources() {
      this.dialogResize++;
    },
    clearData() {
      this.info = {
        scheduleId: "",
        scheduleTypeId: "",
        scheduleConfigId: "",
        schoolId: this.schoolId,
        partition: "",
        scheduleName: "",
        broadcastType: "",
        scene: "",
        resourceType: "",
        frequency: "",
        volume: "",
        broadcastResources: "",
        resourcesName: "",
        broadcastContent: "",
        broadcastStartTime: "",
        broadcastEndTime: "",
        week: "",
        remarks: ""
      };
      this.areaValue = [];
    },
    handleClose() {
      this.clearData();
      this.dialogVisible = false;
    },
    submit() {
      if (this.info.scheduleTypeId === "") {
        this.$message("请选择作息名称！");
        return;
      }
      if (this.info.scheduleConfigId === "") {
        this.$message("请选择作息表任务！");
        return;
      }
      if (this.info.scheduleName === "") {
        this.$message("请填写广播名称！");
        return;
      }
      if (this.broadcastBrand === 0) {
        if (this.partition.length < 1) {
          this.$message("请选择广播分区！");
          return;
        }
      } else {
        if (this.areaValue.length < 1) {
          this.$message("请选择广播分区！");
          return;
        }
      }
      if (this.info.broadcastType === "") {
        this.$message("请选择广播类型！");
        return;
      }
      if (this.info.scene === "") {
        this.$message("请选择应用场景！");
        return;
      }
      if (this.info.resourceType === "") {
        this.$message("请选择资源类型！");
        return;
      }
      if (this.info.frequency === "") {
        this.$message("请填写广播次数！");
        return;
      }
      if (this.info.volume === "") {
        this.$message("请填写广播音量！");
        return;
      }
      if (this.info.resourceType == 0 && this.info.broadcastResources == "") {
        this.$message("请选择广播资源！");
        return;
      }
      if (this.info.resourceType == 1 && this.info.broadcastContent == "") {
        this.$message("请填写广播内容！");
        return;
      }
      if (this.info.startTime == "") {
        this.$message("请选择广播开始时间！");
        return;
      }
      if (this.info.endTime == "") {
        this.$message("请选择广播结束时间！");
        return;
      }
      let partition;
      if (this.broadcastBrand === 0) {
        partition = this.arrayToString(this.partition);
      } else {
        let selectArea = this.modifyArea(this.areaValue);
        partition = this.arrayToString(selectArea);
      }
      let week = this.arrayToString(this.week.sort());
      let req = {
        scheduleTypeId: this.info.scheduleTypeId,
        scheduleConfigId: this.info.scheduleConfigId,
        schoolId: this.info.schoolId || this.schoolId,
        partition: partition,
        scheduleName: this.info.scheduleName,
        broadcastType: this.info.broadcastType,
        scene: this.info.scene,
        resourceType: this.info.resourceType,
        frequency: this.info.frequency,
        volume: this.info.volume,
        broadcastResources: this.info.broadcastResources,
        broadcastContent: this.info.broadcastContent,
        broadcastStartTime: this.info.broadcastStartTime,
        broadcastEndTime: this.info.broadcastEndTime,
        week: week,
        remarks: this.info.remarks
      };
      if (this.id != 0) {
        req = Object.assign(req, {
          scheduleId: this.id,
          taskId: this.info.taskId
        });
      }
      this.operate(req);
    },
    async operate(req) {
      const loading = this.$loading({
        lock: true,
        text: "",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let res = await this.$Http.addOrEditRestBroadcast(req, true);
      // console.log(res)
      loading.close();
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功！"
        });
        this.handleClose();
        this.$emit("getBroadList");
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取单个作息广播信息
    async getRestBroadcastInfo() {
      let req = {
        scheduleId: this.id
      };

      let res = await this.$Http.getRestBroadcastInfo(req);
      // console.log(res)
      if (res.code == 200) {
        // console.log(res.data)
        this.info = res.data;
        this.week = this.stringToNumberArray(res.data.week);
        if (this.broadcastBrand == 0) {
          this.partition = this.stringToArray(res.data.partition);
        } else {
          let arrayTemp = this.stringToArray(res.data.partition);
          // console.log(arrayTemp)
          this.areaValue = arrayTemp.map((element) => {
            let arr = element.split("_");
            let newArray = [arr[0],element];
            return newArray;
          })
          // this.areaValue = this.stringToArray(res.data.partition);
        }
      } else if (res.code == 101) {
        this.info = {};
        this.partition = [];
        this.week = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getTaskList() {
      let req = {
        scheduleTypeId: this.restSelected
      };

      let res = await this.$Http.getBroadcastRestTask(req);
      // console.log(res)
      if (res.code == 200) {
        // console.log(res.data)
        this.taskList = res.data || [];
      } else if (res.code == 101) {
        this.taskList = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    modify(list) {
      let array = list;
      let options = array.map((element) => {
        let children = element.subregions.map((item) => {
          return {
            label: item.name,
            value: item.index
          }
        });
        return {
          label: element.areaName,
          value: element.areaNum,
          children: children
        }
      })
      this.areaList = options;
    },
    // 应急广播-获取分区信息
    async getBroadcastAreaInfo() {
      let req = {
        schoolId: this.schoolId
      };

      let res = await this.$Http.getBroadcastAreaInfo(req);
      // console.log(res)
      if (res.code == 200) {
        let list = res.data || [];
        if( this.broadcastBrand === 0) {
          this.partitionList = list;
        } else {
          this.modify(list);
        }
        
        // console.log(this.partitionList);
      } else if (res.code == 101) {
        this.partitionList = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    arrayToString(arr) {
      let str = arr.join(",");
      return str;
    },
    stringToArray(str) {
      let arr = str.split(",");
      return arr;
    },
    stringToNumberArray(str) {
      let arrTemp = str.split(",");
      let arr = arrTemp.map((element) => {
        return Number(element);
      });
      return arr;
    }
  }
};
</script>
<style lang="scss" scoped></style>
